import { useState, useContext, useEffect, useRef } from "react";
import {
  DotsLoader,
  Footer,
  Header,
  MapLocation,
  Calender,
  LoginHeader,
  NoDataFound,
} from "../../components";
import "./styles.css";
import { Images } from "../../theme";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ProductCard from "../../components/ProductCard";
import { GlobalContext } from "../../context/GlobalContext";
import { useTranslation } from "react-i18next";
import { FindRoom, CreateRoom } from "../../services/FirebaseCalls";
import moment from "moment";

export default function ProductDetail() {
  const getContextItems = useContext(GlobalContext);
  let {
    get_specific_item,
    imageUrl,
    specificItemData,
    other_few_item_by_user_id,
    secondLoader,
    otherItemByUserId,
    isLoading,
    thirdLoader,
    user_data,
    loginData,
    check_availibility,
    calenderAvailibility,
    checkAvailibility,
    changeAvailibility,
    checkLoation,
    locationData,
    get_item_comments,
    itemComments,
  } = getContextItems;
  const { t } = useTranslation();

  let navigate = useNavigate();
  const uselocation = useLocation();
  let propsData = uselocation.state?.item;
  let categoryData = uselocation.state?.categoryData;

  const [isActiveLogin, setIsActiveLogin] = useState(false);

  let weeklyPrice = parseFloat(specificItemData.weekly_price) / 7;
  let monthlyPrice = parseFloat(specificItemData.monthly_price) / 30;

  const [description, setDescription] = useState(true);
  const [imageChange, setImageChange] = useState(null);
  const [selectDay, setSelectDay] = useState(false);

  useEffect(() => {
    user_data();
    propsData?.id && get_specific_item(propsData?.id);
    propsData?.user_id && other_few_item_by_user_id(propsData?.user_id);
    checkLoation(propsData.latitude, propsData.longitude);
    get_item_comments(propsData?.id);
  }, []);

  const inputRef = useRef(null);
  const handleClick = (inputRef, value) => {
    setSelectDay(value);
    inputRef.current.openCalendar();
  };

  function renderContinue(payload) {
    loginData?.id
      ? navigate("/CheckOut", {
          state: { payload },
        })
      : setIsActiveLogin(true);
  }

  function checkAvailability() {
    check_availibility(specificItemData.id);
  }

  async function renderChat() {
    let roomId;
    let see = await FindRoom({
      collectionName: "chatRoom",
      ids: [specificItemData.user_id, loginData?.id],
    });

    let receiverUser = {
      firstname: specificItemData.firstname,
      lastname: specificItemData.lastname,
      profileImagePath: specificItemData.profileImagePath,
      id: specificItemData.user_id,
    };

    if (!see.size) {
      let payload = {
        [specificItemData.user_id]: true,
        [loginData?.id]: true,
        createdAt: moment(Date.now()).format("MM-DD-YYYY hh:mm a"),
        receiverUser: receiverUser,
        senderUser: loginData,
      };
      let check = await CreateRoom({ collectionName: "chatRoom", payload });
      roomId = check.id;
    } else {
      roomId = see.docs[0]?.id;
    }
    navigate("/Inbox", {
      state: { roomId: roomId, receiverUser: receiverUser },
    });
  }

  return (
    <>
      {loginData?.id ? (
        <Header />
      ) : (
        <LoginHeader
          loginIsActive={isActiveLogin}
          setIsActiveLogin={setIsActiveLogin}
        />
      )}
      <div className="container">
        <div className="row">
          <div className="col-12 mt-3 mb-3">
            <Link to="/">
              <span className="homeHeading">{t("Home")}</span>
            </Link>
            {categoryData?.name ? (
              <span className="arrowStyle">
                <img src={Images.ArrowNew} alt="image" />
              </span>
            ) : null}
            <span className="homeHeading">{categoryData?.name}</span>
            <span className="arrowStyle">
              <img src={Images.ArrowNew} alt="image" />
            </span>
            <span className="pageHeading">{specificItemData.title}</span>
          </div>
        </div>
      </div>

      {secondLoader ? (
        <DotsLoader />
      ) : specificItemData.id ? (
        <>
          <div className="container">
            <div className="container-fliud">
              <div className="wrapper row">
                <div className="preview col-md-7">
                  <div className="preview-pic tab-content">
                    <div className="tab-pane active" id="pic-1">
                      <img
                        src={
                          imageChange
                            ? imageChange
                            : specificItemData.images?.length &&
                              `${imageUrl}${specificItemData?.images[0]}`
                        }
                        alt="image"
                      />
                    </div>
                  </div>
                  <ul className="preview-thumbnail nav nav-tabs">
                    {specificItemData.images?.map((val) => {
                      return (
                        <li
                          className="active"
                          onClick={() => setImageChange(`${imageUrl}${val}`)}
                        >
                          <a data-target="#pic-1" data-toggle="tab">
                            <img src={`${imageUrl}${val}`} alt="image" />
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="preview col-md-5">
                  <div className="card">
                    <h1 className="productName">{specificItemData.title}</h1>
                    <div>
                      <img
                        className="locationIconN"
                        src={Images.locationIcon}
                        alt="image"
                      />
                      <span className="locationText">
                        {specificItemData.location}
                      </span>
                    </div>
                    <div onClick={renderChat}>
                      <img
                        className="elephantIcon"
                        src={
                          specificItemData?.profileImagePath
                            ? `${imageUrl}${specificItemData?.profileImagePath}`
                            : Images.user
                        }
                        alt="image"
                      />
                      <span className="elephantText">
                        {specificItemData.firstname} {specificItemData.lastname}
                      </span>
                      <img
                        className="message-arrow"
                        src={Images.locatate}
                        alt="image"
                      />
                    </div>
                    <div>
                      <img
                        className="ratingIcon"
                        src={Images.ratingIcon}
                        alt="image"
                      />
                      <span className="ratingText">
                        {specificItemData.rating ? specificItemData.rating : 0}
                      </span>
                      <span className="reviewCountText">
                        (120 {t("Review")})
                      </span>
                      {/* <span className="reviewWriteText">Write a review</span> */}
                    </div>
                    <div className="row priceCartBox">
                      <div className="col-md-4 p-1">
                        <div
                          className="card"
                          onClick={() => handleClick(inputRef, 1)}
                          style={{
                            borderColor: selectDay == 1 ? "#005494" : "#DFDFDF",
                          }}
                        >
                          <span className="cartPrice">{t("Daily")}</span>
                          <div className="text-center pt-1 pb-2">
                            <span className="priceStyle">
                              ${specificItemData.daily_price}
                            </span>
                            <span className="dayStyle">/{t("Day")}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 p-1">
                        <div
                          className="card"
                          onClick={() => handleClick(inputRef, 2)}
                          style={{
                            borderColor: selectDay == 2 ? "#005494" : "#DFDFDF",
                          }}
                        >
                          <span className="cartPrice">{t("Weekly")}</span>
                          <div className="text-center pt-1 pb-2">
                            <span className="priceStyle">
                              ${weeklyPrice.toFixed(0)}
                            </span>
                            <span className="dayStyle">/{t("Day")}</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 p-1">
                        <div
                          className="card"
                          onClick={() => handleClick(inputRef, 3)}
                          style={{
                            borderColor: selectDay == 3 ? "#005494" : "#DFDFDF",
                          }}
                        >
                          <span className="cartPrice">{t("Monthly")}</span>
                          <div className="text-center pt-1 pb-2">
                            <span className="priceStyle">
                              ${monthlyPrice.toFixed(0)}
                            </span>
                            <span className="dayStyle">/{t("Day")}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {checkAvailibility ? (
                      <Calender
                        selectDay={selectDay}
                        specificItemData={specificItemData}
                        categoryData={categoryData}
                        clearClick={changeAvailibility}
                        renderContinue={renderContinue}
                        calenderAvailibility={calenderAvailibility}
                      />
                    ) : thirdLoader ? (
                      <div className="m-3">
                        <DotsLoader />
                      </div>
                    ) : (
                      <div>
                        <button
                          class="btn-custom btn-light btnProductDetails"
                          onClick={checkAvailability}
                        >
                          {t("Check_Availability")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-7 col-12 mt-4 mb-3 product-desc">
                <span
                  className={
                    description ? "DescriptionHeading" : "unActiveDescHeading"
                  }
                  onClick={() => setDescription(true)}
                >
                  {t("Description")}
                </span>
                <span
                  className={
                    !description ? "ActiveReviewHeading" : "ReviewHeading"
                  }
                  onClick={() => setDescription(false)}
                >
                  {t("Reviews")}
                </span>

                <hr />
                {description ? (
                  <div>
                    <p className="ReviewDescription">
                      {specificItemData.description}
                    </p>
                  </div>
                ) : (
                  <div>
                    <p className="ReviewDescription">
                      {/* {itemComments} */}
                      <p>{t("Reviews")}</p>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {specificItemData.id && (
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h1 className="addressHeading">{t("Location")}</h1>
                </div>
              </div>
              <div className="row">
                <div className="col-md-7">
                  <MapLocation data={specificItemData} zoom={11} />
                  {/* <img style={{ width: "100%" }} src={Images.MapImg} alt="image" /> */}
                </div>
              </div>
            </div>
          )}

          {locationData.id ? (
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-5">
                  <div className="detailMapCard">
                    <div className="row">
                      <div className="col-6">
                        <di className="row">
                          <div className="col-lg-4 col-5 detailMapHeading">
                            {t("District")}
                          </div>
                          <div className="col-lg-8 col-7 detailMapDes">
                            {locationData.country}
                          </div>
                        </di>
                      </div>
                      <div className="col-6">
                        <di className="row">
                          <div className="col-lg-4 col-5 detailMapHeading">
                            {t("Area")}
                          </div>
                          <div className="col-lg-8 col-7 detailMapDes">
                            {locationData.state}
                          </div>
                        </di>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <di className="row">
                          <div className="col-lg-5 col-6 detailMapHeading">
                            {t("City")} :
                          </div>
                          <div className="col-lg-7 col-6 detailMapDes">
                            {locationData.city}
                          </div>
                        </di>
                      </div>
                      <div className="col-6">
                        <di className="row">
                          <div className="col-lg-4 col-5 detailMapHeading">
                            {t("Territory")}
                          </div>
                          <div className="col-lg-8 col-7 detailMapDes">
                            {locationData.terrotary}
                          </div>
                        </di>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <NoDataFound />
      )}

      <div className="container">
        <div className="row">
          <div className="col-6 col-lg-8 mt-5">
            <h1 className="addressHeading">
              {t("Other_Items_From")} {specificItemData.firstname}{" "}
              {specificItemData.lastname}
            </h1>
          </div>
          <Link
            className="col-6 col-lg-4 mt-5"
            to="/searchbycategory"
            state={{ byUserId: specificItemData?.user_id }}
            style={{ justifyContent: "center", textAlign: "right" }}
          >
            <button class="btn-custom btn-light mb-5">{t("View_All")}</button>
          </Link>
        </div>
      </div>

      <div className="container">
        <div className="row">
          {isLoading ? (
            <DotsLoader />
          ) : otherItemByUserId.length ? (
            otherItemByUserId.map((val, ind) => {
              return (
                <div className="col-lg-3 col-md-6 col-12">
                  <ProductCard data={val} imageUrl={imageUrl} />
                </div>
              );
            })
          ) : (
            <div className="d-flex justify-content-center">
              <h3 className="addressHeading">
                {t("Ask")} {specificItemData.firstname}{" "}
                {specificItemData.lastname} {t("For")}
                {t("More_Item")}
              </h3>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}
